// extracted by mini-css-extract-plugin
module.exports = {"header":"navbar_header__1CbJr","nav":"navbar_nav__cQeTx","logoLink":"navbar_logoLink__om3WM","logoText":"navbar_logoText__GQu_z"};